import axios from './index'
// 家长端学生下拉接口
export const parentselect = params => {
  return axios.get(`api/8100/class/selectTempClassStudents`, params)
}
// 集训下拉
export const jxselect = params => {
  return axios.get(`api/8100//class/selectTempTraining`, params)
}
// 家长端学情分析
export const parentxqfx = (params) => {
    return axios.post(`api/8720/studyAnalysis/getParentsStudyAnalysis`, params)
}